import { HexTile } from "./Hexagon";

// ----------------------------------------------------------------------

const initialsOf = (label: string): string => {
  const words = label.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};

interface PatientHexAvatarProps {
  /** Nome do paciente; as iniciais saem daqui */
  name: string;
  size?: number;
}

/** Avatar de paciente no formato do hexágono dos ativos, com as iniciais do nome */
export default function PatientHexAvatar({ name, size = 40 }: PatientHexAvatarProps) {
  return <HexTile label={name} size={size} initials={initialsOf(name)} />;
}
